export default __webpack_public_path__ + "static/media/sign_r.2f9b8d8d.png";